import React, { useState } from "react";
import { toast } from "sonner";
import { Checkbox } from "./ui/checkbox";
import { setPortfolioConsent } from "../lib/api";

export const PORTFOLIO_CONSENT_TEXT =
  "I allow GreenFlow Landcare & Irrigation, LLC to use my landscape concept image for portfolio and marketing purposes, including display on their website and social media.";

export default function PortfolioConsent({ session, setSession }) {
  const [checked, setChecked] = useState(!!session.portfolio_consent?.granted);
  const [saving, setSaving] = useState(false);
  const change = async (v) => {
    const granted = v === true;
    setChecked(granted);
    setSaving(true);
    try {
      const consent = await setPortfolioConsent(session.id, granted);
      setSession({ ...session, portfolio_consent: consent });
    } catch {
      setChecked(!granted);
      toast.error("Could not save your choice. Please try again.");
    } finally {
      setSaving(false);
    }
  };
  return (
    <label data-testid="portfolio-consent-row" className="mt-4 flex items-start gap-2.5 rounded-xl bg-white/10 p-3 text-xs sm:text-sm text-emerald-50 cursor-pointer">
      <Checkbox data-testid="portfolio-consent-checkbox" checked={checked} disabled={saving} onCheckedChange={change}
        className="mt-0.5 border-white/70 data-[state=checked]:bg-white data-[state=checked]:text-[#092C15]" />
      <span>{PORTFOLIO_CONSENT_TEXT} <span className="text-emerald-100/60">(Optional)</span></span>
    </label>
  );
}
